import Typography from '@components/Typography';
import Price from '@components/ui/price';
import {
  FORM_DATE_FORMAT,
  URL_DATE_FORMAT,
  convertStringDateFormat,
} from '@utils/dateUtil';
import { useDevice } from '@contexts/device';

import {
  BodyWrapper,
  TransferItemContainer,
  InfoWrapper,
  PriceInfoWrapper,
  PriceWrapper,
  RadioButton,
  TransferTypeWrapper,
} from './styled';
import { TransferItemProps } from './props';

const TransferItemComponent = ({
  transfer,
  selectedTransferItem,
  setSelectedTransfer,
  isDeparture,
  minPriceItem,
}: TransferItemProps) => {
  const { isDesktop } = useDevice();
  return (
    <TransferItemContainer>
      <BodyWrapper>
        <RadioButton
          type='radio'
          checked={selectedTransferItem?.productId === transfer?.productId}
          onChange={() => setSelectedTransfer(transfer)}
        />
        <TransferTypeWrapper onClick={() => setSelectedTransfer(transfer)}>
          <InfoWrapper>
            <Typography variant='caption1' color='D400' weight='SemiBold'>
              {transfer.name}
            </Typography>
          </InfoWrapper>
          <Typography variant='caption2' color='D100' weight='Regular'>
            {isDeparture
              ? `Havalimanı - Otel (${convertStringDateFormat(
                  transfer.date,
                  URL_DATE_FORMAT,
                  FORM_DATE_FORMAT
                )})`
              : `Otel - Havalimanı (${convertStringDateFormat(
                  transfer.date,
                  URL_DATE_FORMAT,
                  FORM_DATE_FORMAT
                )})`}
          </Typography>
        </TransferTypeWrapper>
        <PriceWrapper>
          <Typography variant='caption2' color='D200'>
            {transfer.trySalePrice - (minPriceItem?.trySalePrice || 0) === 0
              ? 'Paket Fiyatına Dahil'
              : 'Paket Fiyatına Ek'}
          </Typography>
          <PriceInfoWrapper>
            <Price
              price={transfer.trySalePrice - (minPriceItem?.trySalePrice ?? 0)}
              fontSize={isDesktop ? 36 : 30}
              isPackage={true}
            />
          </PriceInfoWrapper>
        </PriceWrapper>
      </BodyWrapper>
    </TransferItemContainer>
  );
};
export default TransferItemComponent;
